module.exports = __webpack_public_path__ + "static/media/medManager_01.548ba78c.gif";